export const siteOrigin = "https://pre6.ai";

export type ProductId = "lens" | "costing" | "machinist" | "ppap";

export type Product = {
	name: string;
	/** Each product is its own app, at this path on {@link siteOrigin}. */
	href: string;
	/** What the product covers, in a few words. */
	detail: string;
	tagline: string;
};

/** Key order is the navbar's order. */
export const products: Record<ProductId, Product> = {
	lens: { name: "Lens", href: "/lens/", detail: "Ballooning, inspection and SPC", tagline: "A QMS with Frontier Intelligence." },
	costing: { name: "Costing", href: "/costing/", detail: "Quotes, DFM and should-cost", tagline: "Physics-aware quotation, in seconds." },
	machinist: { name: "Machinist", href: "/machinist/", detail: "CAM programming", tagline: "Your AI CAM programmer." },
	ppap: { name: "PPAP", href: "/ppap/", detail: "Compliance documents", tagline: "PPAP documentation in minutes." },
};
